import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/baseQueryWithAuth';

const mdmsUrl = process.env.REACT_APP_MDMS_URL;
// Define a service using a base URL and expected endpoints
export const arrearConfigApi = createApi({
  reducerPath: 'arrearConfigApi',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getAllArrearData: builder.query({
      query: (params) => ({
        url: `${mdmsUrl}/prepaid-engine/arrear_configuration/${params}`
      }),
      providesTags: ['getAllArrear']
    }),
    updateArrearDataBulk: builder.mutation({
      query: (data) => ({
        url: `${mdmsUrl}/prepaid-engine/arrear_configuration/many/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['getAllArrear']
    }),
    deleteArrearData: builder.mutation({
      query: (id) => ({
        url: `${mdmsUrl}/prepaid-engine/arrear_configuration/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['getAllArrear']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllArrearDataQuery,
  useUpdateArrearDataBulkMutation,
  useDeleteArrearDataMutation
} = arrearConfigApi;
